import './mattisons/style';
import FormStructure from './mattisons/form_structure';

export default FormStructure;